if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.selectedVariantId = this.variantIdInput.val;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const formData = new FormData(this.form);
        const variantIdInput = $(this.variantIdInput);
        const selectedVariant = $(`[data-variant-option-id="${variantIdInput.val()}"]`);
        const bundleUpsell = this.getBundleUpsell();
        const companions = this.getSelectedCompanionsFromUpsells();

        if (companions.length > 0 && bundleUpsell) {
          this.submitBundleAdd(formData, selectedVariant, bundleUpsell, companions, evt);
          return;
        }

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => this.handleAddResponse(response, formData, selectedVariant, [], evt))
          .catch((e) => {
            console.error(e);
          })
          .finally(() => this.finalizeSubmit(evt));
      }

      submitBundleAdd(formData, selectedVariant, bundleUpsell, companions, evt) {
        const bundleId = bundleUpsell.generateBundleId();
        const parentHandle = bundleUpsell.dataset.parentHandle;
        const quantity = parseInt(formData.get('quantity') || '1', 10);
        const mainProperties = this.extractLineProperties(formData);

        mainProperties._bundle_id = bundleId;

        const items = [
          {
            id: parseInt(formData.get('id'), 10),
            quantity,
            properties: mainProperties,
          },
        ];

        companions.forEach((companion) => {
          items.push({
            id: companion.variantId,
            quantity: 1,
            properties: {
              _bundle_id: bundleId,
              _bundle_parent: parentHandle,
            },
          });
        });

        const payload = { items };

        if (this.cart) {
          payload.sections = this.cart.getSectionsToRender().map((section) => section.id);
          payload.sections_url = window.location.pathname;
          this.cart.setActiveElement(document.activeElement);
        }

        fetch(`${routes.cart_add_url}`, {
          ...fetchConfig(),
          headers: {
            ...fetchConfig().headers,
            'X-Requested-With': 'XMLHttpRequest',
          },
          body: JSON.stringify(payload),
        })
          .then((response) => response.json())
          .then((response) => this.handleAddResponse(response, formData, selectedVariant, companions, evt))
          .catch((e) => {
            console.error(e);
          })
          .finally(() => this.finalizeSubmit(evt));
      }

      handleAddResponse(response, formData, selectedVariant, companions, evt) {
        if (response.status) {
          publish(PUB_SUB_EVENTS.cartError, {
            source: 'product-form',
            productVariantId: formData.get('id'),
            errors: response.errors || response.description,
            message: response.message,
          });
          this.handleErrorMessage(response.description);

          const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
          if (!soldOutMessage) return;
          this.submitButton.setAttribute('aria-disabled', true);
          this.submitButtonText.classList.add('hidden');
          soldOutMessage.classList.remove('hidden');
          this.error = true;
          return;
        }

        this.getBundleUpsell()?.clearSelection?.();

        if (!this.cart) {
          window.location = window.routes.cart_url;
          return;
        }

        this.normalizeAddResponse(response, formData.get('id'));

        const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
        if (!this.error)
          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: 'product-form',
            productVariantId: formData.get('id'),
            cartData: response,
          }).then(async () => {
            await this.checkAndUpdateCart(selectedVariant, companions);
            CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
          });
        this.error = false;
        const quickAddModal = this.closest('quick-add-modal');
        if (quickAddModal) {
          document.body.addEventListener(
            'modalClosed',
            () => {
              setTimeout(() => {
                CartPerformance.measure('add:paint-updated-sections', () => {
                  this.cart.renderContents(response);
                });
              });
            },
            { once: true }
          );
          quickAddModal.hide(true);
        } else {
          CartPerformance.measure('add:paint-updated-sections', () => {
            this.cart.renderContents(response);
          });
        }
      }

      finalizeSubmit(evt) {
        this.submitButton.classList.remove('loading');
        if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
        if (!this.error) this.submitButton.removeAttribute('aria-disabled');
        this.querySelector('.loading__spinner').classList.add('hidden');

        CartPerformance.measureFromEvent('add:user-action', evt);
      }

      normalizeAddResponse(response, mainVariantId) {
        if (response.key || !response.items?.length) return response;

        const mainVariant = parseInt(mainVariantId, 10);
        const mainItem =
          response.items.find((item) => item.variant_id === mainVariant) || response.items[response.items.length - 1];

        response.key = mainItem.key;
        if (!response.id) response.id = mainItem.variant_id;

        return response;
      }

      extractLineProperties(formData) {
        const props = {};
        for (const [key, value] of formData.entries()) {
          const match = key.match(/^properties\[(.+)\]$/);
          if (match && value) {
            props[match[1]] = value;
          }
        }
        return props;
      }

      getBundleUpsell() {
        const productId = this.dataset.productId;
        if (!productId) return null;
        return document.querySelector(`product-bundle-upsell[data-product-id="${productId}"]`);
      }

      getSelectedCompanionsFromUpsells() {
        const productId = this.dataset.productId;
        if (!productId) return [];

        const upsells = document.querySelectorAll(`product-bundle-upsell[data-product-id="${productId}"]`);
        for (const upsell of upsells) {
          const selected = upsell.getSelectedCompanions?.();
          if (selected?.length > 0) {
            return selected;
          }
        }
        return [];
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }

      computeMinDate(leadDay, cutoffTime) {
        let minDate = moment();
        leadDay = parseInt(leadDay, 10) || 0;
        cutoffTime = parseInt(cutoffTime, 10);

        if (cutoffTime > 0) {
          const todayCutoffTime = moment().set({ hour: cutoffTime, minute: 0, second: 0, millisecond: 0 });
          if (minDate.isSameOrAfter(todayCutoffTime)) {
            minDate.add(1, 'days');
          }
          minDate.add(leadDay, 'days');
        } else {
          minDate.add(leadDay, 'days');
        }

        return minDate;
      }

      async updateCart(attributes, minDate) {
        const collectionDateName = 'collection-date';
        if (!attributes[collectionDateName]) {
          return;
        }

        const currentCollectionDate = attributes[collectionDateName];
        const currentDate = moment(currentCollectionDate, 'DD-MM-YYYY');

        if (minDate.isAfter(currentDate, 'day')) {
          const data = { [collectionDateName]: minDate.format('DD-MM-YYYY') };

          return $.ajax({
            type: 'POST',
            url: '/cart/update.js',
            data: JSON.stringify({ attributes: data }),
            dataType: 'json',
            async: false,
            contentType: 'application/json',
          });
        }
      }

      async getCart() {
        return fetch('/cart.js')
          .then((response) => response.json())
          .then((cart) => cart)
          .catch((error) => {
            console.error('Error fetching cart:', error);
            return null;
          });
      }

      async checkAndUpdateCart(selectedVariant, companions = []) {
        const cart = await this.getCart();

        if (!cart?.attributes) return;

        let maxMinDate = this.computeMinDate(
          selectedVariant.data('lead-day'),
          selectedVariant.data('order-cutoff-time')
        );

        companions.forEach((companion) => {
          const companionMinDate = this.computeMinDate(companion.leadDay, companion.orderCutoffTime);
          if (companionMinDate.isAfter(maxMinDate, 'day')) {
            maxMinDate = companionMinDate;
          }
        });

        try {
          await this.updateCart(cart.attributes, maxMinDate);
        } catch (err) {
          console.log('Error while updating cart.');
        }
      }
    }
  );
}
